export const RESCHEDULE_CLASSES_FILTER_LABELS = {
  primaryInstructors: 'Primary instructors',
  secondaryInstructors: 'Secondary instructors',
  academyModules: 'Modules',
  classType: 'Class Type',
  lectureType: 'Lecture Type',
  fromDate: 'From date',
  toDate: 'To date',
};
